export class Spinner {
}
